import axios from "axios";
import { analyticsSlice, callTypes } from "./analyticsSlice";

const ANALYTICS_API_URL = process.env.REACT_APP_ANALYTICS_API_URL;
const { actions } = analyticsSlice;

export const queryUsersPerYear = (collection, level, value) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.getMembersL30 }));

  let result = queryContructor(value, collection, level, dispatch);

  return result.then((response) => {
    // Registered users by year
    let usersTotal = 0;
    response.data.result.map((items, index) => {
      let count = 0;
      for (const item of items) {
        count += (item) ? parseInt(item.count) : 0;
      }
      dispatch(
        actions.usersPerYear({
          series: count,
          year: index,
        })
      );
      usersTotal += count;
    });

    dispatch(actions.usersTotal({ usersTotal }));

    // Calculate Total
    let totalCount = 0;
    for (const items of response.data.result) {
      for (const item of items) {
        totalCount += parseInt(item.count);
      }
    }

    // The results correspond to different years, accordingly we need to group them by role
    let groupedByRole = [];

    for (const items of response.data.result) {
      for (const item of items) {
        const existent = groupedByRole.filter(i => i.f_role === item.f_role);

        if (existent.length < 1) {
          //console.log('[GROUP BY ROLE]: ', item.f_role, parseInt(item.count), totalCount);
          groupedByRole.push({ f_role: item.f_role, count: parseInt(item.count), total: totalCount });
        } else {
          existent[0].count += parseInt(item.count);
          console.log(existent)
        }
      }
    }

    return groupedByRole.map((it) => {
      return dispatch(
        actions.fetchedMembersL30({
          labels: it.f_role,
          series: parseInt(it.count),
          percentages: (((parseInt(it.count)/it.total)*100).toFixed(2)) + "%"
        })
      );
    });
  })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.getMembersL30 })
      );
    });
};

export const queryActiveUsersYear = (collection, level, value) => (
  dispatch
) => {
  dispatch(actions.startCall({ callType: callTypes.getMembersL30 }));

  let result = queryContructor(value, collection, level, dispatch);
  return result
    .then((response) => {
      response.data.result.map((item, index) => {
        dispatch(
          actions.activeUsersPerYear({
            series: (item[0]) ? item[0].a_uid : 0,
            year: index,
          })
        );

        if (index === (response.data.result.length - 1)) {
          dispatch(actions.activeMembersYear({ activeMembersYear: (item[0]) ? item[0].a_uid : 0 }))
        }
      });
    })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.getMembersL30 })
      );
    });
};

export const queryActiveUsersMonth = (collection, level, value) => (
  dispatch
) => {
  dispatch(actions.startCall({ callType: callTypes.getMembersL30 }));

  let result = queryContructor(value, collection, level, dispatch);
  return result
    .then((response) => {
      response.data.result.map((item, index) => {
        dispatch(
          actions.activeUsersPerMonth({
            series: (item[0]) ? item[0].a_uid : 0,
            month: index,
          })
        );

        if (index === (response.data.result.length - 1)) {
          dispatch(actions.activeMembersMonth({ activeMembersMonth: (item[0]) ? item[0].a_uid : 0 }))
        }
      });
    })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.getMembersL30 })
      );
    });
};

export const queryActiveUsersDay = (collection, level, value) => (
  dispatch
) => {
  dispatch(actions.startCall({ callType: callTypes.getMembersL30 }));

  let result = queryContructor(value, collection, level, dispatch);
  return result
    .then((response) => {
      response.data.result.map((item, index) => {
        dispatch(
          actions.activeUsersPerDay({
            series: (item[0]) ? item[0].a_uid : 0,
            day: index,
          })
        );

        if (index === (response.data.result.length - 1)) {
          dispatch(actions.activeMembersToday({ activeMembersToday: (item[0]) ? item[0].a_uid : 0 }))
        }
      });
    })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.getMembersL30 })
      );
    });
};

export const queryAppInstallations = (collection, level, value) => (
  dispatch
) => {
  dispatch(actions.startCall({ callType: callTypes.getMembersL30 }));

  let result = queryContructor(value, collection, level, dispatch);
  return result
    .then((response) => {
      return response.data.result[0].map((item) => {
        let label;
        if (item["f_device-type"].includes("google")) {
          label = "Android";
        } else {
          label = "IOs";
        }
        return dispatch(
          actions.appInstallations({
            series: item.count,
            labels: label,
          })
        );
      });
    })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.getMembersL30 })
      );
    });
};

export const queryUsersPerMonth = (collection, level, value) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.getMembersL30 }));

  let result = queryContructor(value, collection, level, dispatch);
  return result
    .then((response) => {
      return response.data.result.map((item, index) => {
        let count = 0;
        let month = index;
        item.map((users) => {
          return (count = count + parseInt(users.count));
        });
        return dispatch(
          actions.usersPerMonth({
            series: count,
            month: month,
          })
        );
      });
    })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.getMembersL30 })
      );
    });
};

export const queryUsersPerDay = (collection, level, value) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.getMembersL30 }));

  let result = queryContructor(value, collection, level, dispatch);
  return result
    .then((response) => {
      return response.data.result.map((item, index) => {
        let count = 0;
        let day = index;
        
        item.map((users) => {
          (count += (users.count) ? parseInt(users.count) : 0);
        });

        dispatch(
          actions.usersPerDay({
            series: count,
            day: day,
          })
        );

        if (index === (response.data.result.length - 1)) {
          dispatch(actions.usersToday({ usersToday: count }))
        }
      });
    })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.getMembersL30 })
      );
    });
};

function queryContructor(value, collection, level, dispatch) {
  let body = {
    queries: [],
  };
  value.map(async (year) => {
    body.queries = [
      ...body.queries,
      {
        collection: collection,
        level: level,
        value: year,
      },
    ];
  });

  return axios
    .post(ANALYTICS_API_URL + "/query", body)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.getMembersL30 })
      );
    });
}
